import { render } from "./ManagerData.vue?vue&type=template&id=5deeb203&scoped=true&ts=true"
import script from "./ManagerData.vue?vue&type=script&lang=ts"
export * from "./ManagerData.vue?vue&type=script&lang=ts"

import "./ManagerData.vue?vue&type=style&index=0&id=5deeb203&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5deeb203"]])

export default __exports__